import { render, staticRenderFns } from "./AddPortfolioModal.vue?vue&type=template&id=665b434d&"
import script from "./AddPortfolioModal.vue?vue&type=script&lang=js&"
export * from "./AddPortfolioModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports